export type ExternalLinkIconProps = {
  className?: string;
};

export default ({ className }: ExternalLinkIconProps) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" viewBox="0 0 28 29">
    <path d="M22.1 21v3.3c0 .9-.7 1.6-1.6 1.6H4.7c-.9 0-1.6-.7-1.6-1.6V8.5c0-.9.7-1.6 1.6-1.6H8V3.8H4.7C2.1 3.8 0 5.9 0 8.5v15.8C0 26.9 2.1 29 4.7 29h15.8c2.6 0 4.7-2.1 4.7-4.7V21h-3.1z" />
    <path d="M25.6.9H12.1c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5H22L10.4 15.5l2.1 2.1L24.1 6v9.9c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5V2.4c0-.9-.6-1.5-1.5-1.5z" />
  </svg>
);
